module.exports = __webpack_public_path__ + "assets/img/2.4e5d6b76.png";